var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstaMovil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_864",
    "data-name": "Grupo 864",
    transform: "translate(-297 -21.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_812",
    "data-name": "Grupo 812",
    transform: "translate(296.9 21.153)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_35",
    "data-name": "Elipse 35",
    cx: 10,
    cy: 9.5,
    rx: 10,
    ry: 9.5,
    transform: "translate(0.1 0.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_473",
    "data-name": "Grupo 473",
    transform: "translate(4.589 4.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_147",
    "data-name": "Grupo 147",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144",
    "data-name": "Grupo 144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_234",
    "data-name": "Trazado 234",
    d: "M88.151,544.709H83.537a3.052,3.052,0,0,1-3.048-3.048v-4.614A3.052,3.052,0,0,1,83.537,534h4.614a3.052,3.052,0,0,1,3.048,3.048v4.614A3.052,3.052,0,0,1,88.151,544.709Zm-4.614-9.792a2.133,2.133,0,0,0-2.13,2.13v4.614a2.133,2.133,0,0,0,2.13,2.13h4.614a2.133,2.133,0,0,0,2.13-2.13v-4.614a2.133,2.133,0,0,0-2.13-2.13Z",
    transform: "translate(-80.489 -533.999)",
    fill: "#ff4700"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_145",
    "data-name": "Grupo 145",
    transform: "translate(2.613 2.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_235",
    "data-name": "Trazado 235",
    d: "M117.462,573.714a2.742,2.742,0,1,1,2.742-2.742A2.745,2.745,0,0,1,117.462,573.714Zm0-4.567a1.824,1.824,0,1,0,1.824,1.824A1.826,1.826,0,0,0,117.462,569.147Z",
    transform: "translate(-114.72 -568.229)",
    fill: "#ff4700"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_146",
    "data-name": "Grupo 146",
    transform: "translate(7.556 1.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_236",
    "data-name": "Trazado 236",
    d: "M180.8,558.2a.659.659,0,1,1-.659-.659A.659.659,0,0,1,180.8,558.2Z",
    transform: "translate(-179.481 -557.538)",
    fill: "#ff4700"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaMovil);
export default __webpack_public_path__ + "static/media/InstaMovil.4c9d513a870ea6b27241e5815b1fbaa3.svg";
export { ForwardRef as ReactComponent };